const initialState = {
  keySearch: "",
  expertiseBeans: [],
  windowScrollX: 0,
  windowScrollY: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "API_EXPERTISE_SEARCH":
      return {
        ...state,
        keySearch: action.keySearch,
        expertiseBeans: action.data.expertiseBeans,
      };
    case "EXPERTISE_SET_WINDOW_SCROLL":
      return {
        ...state,
        windowScrollX: action.windowScrollX,
        windowScrollY: action.windowScrollY,
      };
    default:
      return state;
  }
};

export default reducer;
